import { render, staticRenderFns } from "./InternshipDocUpload.vue?vue&type=template&id=4ae1024b"
import script from "./InternshipDocUpload.vue?vue&type=script&lang=js"
export * from "./InternshipDocUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports